import { Routes, Route, HashRouter } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { GlobalContextProvider } from "@context/GlobalContext";
import Login from "@pages/login/Login";
import Default from "@pages/default/Default";
import PrivateRoute from "@hooks/PrivateRoute";
import RPAs from "@pages/RPAs/RPAs";
import CadastraEmpresaRPA from "@pages/RPAs/CadastrarEmpresaRPA/CadastrarEmpresaRPA";
import RegrasRPA from "@pages/RPAs/RegrasRPA/RegrasRPA";
import CadastrarRegrasRPA from "@pages/RPAs/RegrasRPA/CadastrarRegrasRPA/CadastrarRegrasRPA";
import Agendamento from "@pages/agendamento/Agendamento";
import CadastroAgendamento from "@pages/agendamento/cadastroagendamento/CadastroAgendamento";
import Gerenciador from "@pages/gerenciador/Gerenciador";
import CadastrarCertificado from "@pages/gerenciador/CadastrarCertificado/CadastrarCertificado";
import CadastrarDominio from "@pages/gerenciador/CadastrarDominio/CadastrarDominio";
import TourRoute from "@hooks/TourRoute";
import IconSistemaDominio from "@icons/IconSistemaDominio";
import IconPVA from "@icons/IconPVA";
import IconReceitaBX from "@icons/IconReceitaBX";
import CadastroReceitaBX from "@pages/receitabx/CadastroReceitaBX";
import ConsultaReceitaBX from "@pages/receitabx/ConsultaReceitaBX";
import Ibscbs from "@pages/ibscbs/Ibscbs";
import Sigup from "@pages/sigup/Sigup";

export default function Rotas() {
  return (
    <HashRouter>
      <GlobalContextProvider>
        <Routes>
          <Route path="/" element={<Login />}></Route>
          {/* RPAs */}
          <Route
            path="/RPA/EFDContribuicoes"
            element={
              <TourRoute tpStep={1}>
                <PrivateRoute>
                  <Default
                    back
                    icon={<IconPVA />}
                    title="Consulta EFD Contribuições"
                    tpStep={1}
                  >
                    <RPAs />
                  </Default>
                </PrivateRoute>
              </TourRoute>
            }
          ></Route>
          {/* Consultas RPAs */}
          <Route
            path="/RPA/Regras"
            element={
              <TourRoute tpStep={4}>
                <PrivateRoute>
                  <Default
                    back
                    icon={<i className="fa-solid fa-scale-balanced"></i>}
                    title="Regras RPAs"
                    tpStep={4}
                  >
                    <RegrasRPA />
                  </Default>
                </PrivateRoute>
              </TourRoute>
            }
          ></Route>
          <Route
            path="/RPA/Empresa"
            element={
              <TourRoute tpStep={3}>
                <PrivateRoute>
                  <Default
                    icon={<i class="fa-solid fa-gear"></i>}
                    title="Gerenciador Empresas"
                    back
                    tpStep={3}
                  >
                    <Gerenciador />
                  </Default>
                </PrivateRoute>
              </TourRoute>
            }
          ></Route>
          <Route
            path="/RPA/Agendamento"
            element={
              <PrivateRoute>
                <Default
                  icon={<i className="fa-solid fa-calendar-clock"></i>}
                  title="Agendamentos"
                  back
                >
                  <Agendamento />
                </Default>
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/RPA/ReceitaBX"
            element={
              <PrivateRoute>
                <Default icon={<IconReceitaBX />} title="Receita BX" back>
                  <ConsultaReceitaBX />
                </Default>
              </PrivateRoute>
            }
          ></Route>
          {/* Cadastro RPAs */}
          <Route
            path="/RPA/Cadastro/Empresa"
            element={
              <TourRoute tpStep={2}>
                <PrivateRoute>
                  <Default
                    back
                    icon={<i className="fa-solid fa-address-card"></i>}
                    title="Cadastro Empresa"
                    tpStep={2}
                  >
                    <CadastraEmpresaRPA />
                  </Default>
                </PrivateRoute>
              </TourRoute>
            }
          ></Route>
          <Route
            path="/RPA/Cadastro/Regras"
            element={
              <PrivateRoute>
                <Default
                  icon={<i class="fa-solid fa-scale-balanced"></i>}
                  title="Cadastrar/Editar Regras RPAs"
                  back
                >
                  <CadastrarRegrasRPA />
                </Default>
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/RPA/Cadastro/Agendamento"
            element={
              <PrivateRoute>
                <Default
                  icon={<i className="fa-solid fa-calendar-clock"></i>}
                  title="Cadastrar Agendamento"
                  back
                >
                  <CadastroAgendamento />
                </Default>
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="RPA/Cadastro/Certificado"
            element={
              <PrivateRoute>
                <Default
                  icon={<i class="fa-solid fa-file-certificate"></i>}
                  title="Cadastro Certificado"
                  back
                >
                  <CadastrarCertificado />
                </Default>
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="RPA/Cadastro/Dominio"
            element={
              <PrivateRoute>
                <Default
                  icon={<IconSistemaDominio />}
                  title="Cadastro Sistema Dominio"
                  back
                >
                  <CadastrarDominio />
                </Default>
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="RPA/Cadastro/ReceitaBX"
            element={
              <PrivateRoute>
                <Default
                  icon={<IconReceitaBX />}
                  title="Cadastro Receita BX"
                  back
                >
                  <CadastroReceitaBX />
                </Default>
              </PrivateRoute>
            }
          ></Route>
          {/*ibscbs*/}
          <Route path="/ConsultaIbscbs" element={<Ibscbs />}></Route>
          <Route path="/Cadastrar" element={<Sigup />}></Route>

          {/* pagina não encontrada */}
          <Route
            path="*"
            element={<h2 className="error404">Pagina não encontrada</h2>}
          />
        </Routes>
        {/* tooltips */}
        <Tooltip
          id="tooltip-001"
          className="default-tooltip"
          style={{ zIndex: 10 }}
        />
      </GlobalContextProvider>
    </HashRouter>
  );
}
